<template>
  <div>
    <TitleBar>
      <template v-slot:title><translate>Completing Setup</translate></template>
      <template v-slot:buttons>
      </template>
    </TitleBar>
    <div class="content">
      <LoadingSpinner style="z-index: 10000;" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TitleBar from "@/components/TitleBar"
import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner"

export default {
  name: "BanksRedirect",
  components: {TitleBar, LoadingSpinner},
  data() {
    return {
      customers: [],
      filters: {}
    }
  },
  computed: {
    ...mapGetters({
      getMobileAppView: "main/getMobileAppView",
      getMobileApp: "main/getMobileApp"
    })
  },
  created() {
    var query = this.$route.query;

    if ("finish_mollie_authentication" in query) {  // Mollie
      console.log("Mollie finish authentication")
      this.mollieFinishAuthentication(query).then(() => {
        this.$router.push({ name: "IdealPayments" }) // Mollie not supported in mobile app
      }).catch((response)=> {
        this.handleRedirectError(response.data)
      })


    } else if ("consent_id" in query) {  // Enablenow
      console.log("Enablenow grant consent success")
      this.enablenowGrantConsentSuccess(query).then(() => {
        this.handleRedirect()
      }).catch((response)=> {
        this.handleRedirectError(response.data)
      })

      // TODO handle grant consent failure
    } else {
      this.handleRedirect()
    }
  },
  methods: {
    ...mapActions ({
      mollieFinishAuthentication : "bankStore/mollieFinishAuthentication",
      enablenowGrantConsentSuccess: "bankStore/enablenowGrantConsentSuccess"
    }),
    handleRedirect() {
      if(this.getMobileAppView && this.getMobileApp !== "") {
        location.href = "gekko" + this.getMobileApp + "://banks";
      } else {
        this.$router.push({ name: "Bank" });
      }
    },
    handleRedirectError(responseData) {
      this.$store.commit('setAlert', {
        title: this.$gettext("Failed to refresh"),
        text: responseData,
        variant: "error",
        duration: 8
      })

      if(this.getMobileAppView) {
        location.href = "gekkocosts://banks?errormsg=" + responseData;
      } else {
        this.$router.push({ name: "Bank" });
      }
    }
  }
}
</script>

<style scoped>

</style>